<template>
    <div>
        <div class="position-relative">
          <!-- shape Hero -->
          <section class="section-shaped my-0">
              <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-desk">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
              </div>
              <div class="container shape-container d-flex">
                  <div class="col px-0">
                      <div class="row">
                          <div class="col-lg-7">
                              <h1 class="display-3 text-white">{{ $t('home.title') }}</h1>
                              <p class="lead  text-white">{{ $t('home.para1') }}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
          <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg mt--100">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="/img/theme/drakenkop.png" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon
                              name="ni ni-settings-gear-65"
                              class="mb-5"
                              size="lg"
                              type="success"
                              shadow
                              rounded
                            ></icon>
                            <h3>{{ $t('home.title2') }}</h3>
                            <p>{{ $t('home.para2') }}</p>
                            <p>{{ $t('home.para3') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                      <div class="position-relative pl-md-5">
                        <img src="/img/ill/ill-2.svg" class="img-center img-fluid">
                      </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                      <div class="d-flex px-3">
                        <p class="text-white">{{ $t('home.para4') }}</p>
                      </div>
                      <card shadow class="shadow-lg--hover mt-5">
                          <div class="d-flex px-3">
                            <div>
                              <icon name="ni ni-satisfied" gradient="success" color="white" shadow rounded></icon>
                            </div>
                            <div class="pl-4">
                              <h5 class="title text-success">{{ $t('home.role1') }}</h5>
                              <p>{{ $t('home.roleText1') }}</p>
                            </div>
                          </div>
                      </card>
                      <card shadow class="shadow-lg--hover mt-5">
                          <div class="d-flex px-3">
                            <div>
                              <icon name="ni ni-satisfied" gradient="success" color="white" shadow rounded></icon>
                            </div>
                            <div class="pl-4">
                              <h5 class="title text-success">{{ $t('home.role2') }}</h5>
                              <p>{{ $t('home.roleText2') }}</p>
                            </div>
                          </div>
                      </card>
                      <card shadow class="shadow-lg--hover mt-5">
                          <div class="d-flex px-3">
                            <div>
                              <icon name="ni ni-satisfied" gradient="success" color="white" shadow rounded></icon>
                            </div>
                            <div class="pl-4">
                              <h5 class="title text-success">{{ $t('home.role3') }}</h5>
                              <p>{{ $t('home.roleText3') }}</p>
                            </div>
                          </div>
                      </card>
                      <card shadow class="shadow-lg--hover mt-5">
                          <div class="d-flex px-3">
                            <div>
                              <icon name="ni ni-satisfied" gradient="success" color="white" shadow rounded></icon>
                            </div>
                            <div class="pl-4">
                              <h5 class="title text-success">{{ $t('home.role4') }}</h5>
                              <p>{{ $t('home.roleText4') }}</p>
                            </div>
                          </div>
                      </card>
                      <card shadow class="shadow-lg--hover mt-5">
                          <div class="d-flex px-3">
                            <div>
                              <icon name="ni ni-satisfied" gradient="success" color="white" shadow rounded></icon>
                            </div>
                            <div class="pl-4">
                              <h5 class="title text-success">{{ $t('home.role5') }}</h5>
                              <p>{{ $t('home.roleText5') }}</p>
                            </div>
                          </div>
                      </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">{{ $t('home.title3') }}</h2>
                        <p class="lead text-muted">{{ $t('home.paraProjects') }}</p>
                    </div>
                </div>

                <div v-for="projectGroup in groupedProjects" v-bind:key="projectGroup.id"
                    class="row row-grid">
                    <div v-for="project in projectGroup" v-bind:key="project.id"
                        class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                          <a :href="'/project/'+project.slug">
                              <img v-lazy="project.src"
                                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                  style="width: 200px;">
                              <div class="pt-4 text-center">
                                  <h5 class="title">
                                      <span v-if="project.title" class="d-block mb-1">{{ project.title }}</span>
                                      <small v-if="project.role" class="h6 text-muted">{{ project.role }}</small>
                                  </h5>
                              </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import projectsData from '../data/projects.js';

export default {
  name: "home",
  data() {
    return {
      projects: projectsData
    }
  },
  computed: {
    groupedProjects() {
      let grouped = [];
      let index = -1;
      for (let i = 0; i < this.projects.length; i++) {
        if (i % 4 == 0) {
          index++;
          grouped[index] = [];
        }
        grouped[index].push(this.projects[i]);
      }
      return grouped;
    }
  }
};
</script>
